import { ZonedDateTime } from '@internationalized/date';

export type ItemAliasSortOption =
  | 'AliasNameAsc'
  | 'AliasNameDesc'
  | 'AliasTypeAsc'
  | 'AliasTypeDesc'
  | 'CreatedAtAsc'
  | 'CreatedAtDesc'
  | 'UpdatedAtAsc'
  | 'UpdatedAtDesc';

export const enumItemAliasSortOption = {
  AliasNameAsc: 'AliasNameAsc' as const,
  AliasNameDesc: 'AliasNameDesc' as const,
  AliasTypeAsc: 'AliasTypeAsc' as const,
  AliasTypeDesc: 'AliasTypeDesc' as const,
  CreatedAtAsc: 'CreatedAtAsc' as const,
  CreatedAtDesc: 'CreatedAtDesc' as const,
  UpdatedAtAsc: 'UpdatedAtAsc' as const,
  UpdatedAtDesc: 'UpdatedAtDesc' as const,
};

export type InventorySection = 'items' | 'aliases' | 'categories' | 'groups';

export const enumItemAliasType = {
  Buy: 'Buy' as const,
  Sell: 'Sell' as const,
};

export type ItemAliasType = 'Buy' | 'Sell';

export type ItemAliasRecord = {
  id: string;
  itemId: string;
  item: {
    id: string;
    name: string;
  };
  accountId: string;
  account: {
    id: string;
    name: string;
  };
  aliasName: string;
  aliasCode: string | null;
  aliasType: ItemAliasType;
  notes: string | null;
  timestamps: {
    createdAt: ZonedDateTime;
    updatedAt: ZonedDateTime;
  };
};

export type ItemGroupRecord = {
  id: string;
  name: string;
  number: string;
  description: string;
  notes: string;
  defaultPricingUnit: string | null;
  colorHue?: number | null;
  parent: {
    id: string;
    name: string;
  } | null;
  timestamps: {
    createdAt: ZonedDateTime;
    updatedAt: ZonedDateTime;
  };
};

export type ItemDetailRecord = {
  id: string;
  name: string;
  skuNumber: string;
  description: string;
  notes: string;
  category: {
    id: string;
    name: string;
  } | null;
  itemGroup: {
    id: string;
    name: string;
  } | null;
  pricingUnitOverride: string | null;
  effectivePricingUnit: string;
  attributeValues: Record<string, unknown>;
  customAttributes: Record<string, unknown> | null;
  timestamps: {
    createdAt: ZonedDateTime;
    updatedAt: ZonedDateTime;
  };
};

export type ItemRecord = {
  id: string;
  name: string;
  skuNumber: string;
  description: string;
  notes: string;
  category: {
    id: string;
    name: string;
  } | null;
  itemGroup: {
    id: string;
    name: string;
  } | null;
  timestamps: {
    createdAt: ZonedDateTime;
    updatedAt: ZonedDateTime;
  };
};

export type {
  CategoryAttribute,
  CategoryRecord,
} from '../_graphql/queryCategoriesList';
